/* eslint-disable */
import * as Types from './types';

export type HtmlContentFragment = { __typename: 'HtmlContent', contentTextAlign?: string | null, sys: { __typename?: 'Sys', id: string }, htmlContent?: { __typename?: 'HtmlContentHtmlContent', json: object, links: { __typename?: 'HtmlContentHtmlContentLinks', assets: { __typename?: 'HtmlContentHtmlContentAssets', block: Array<{ __typename?: 'Asset', contentType?: string | null, url?: string | null, title?: string | null, width?: number | null, height?: number | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null };

export declare const HtmlContentFragment: import("graphql").DocumentNode;
export const HtmlContentFragmentDoc = /*#__PURE__*/ `
    fragment HtmlContentFragment on HtmlContent {
  __typename
  sys {
    id
  }
  htmlContent {
    json
    links {
      assets {
        block {
          sys {
            id
          }
          contentType
          url
          title
          width
          height
          description
        }
      }
    }
  }
  contentTextAlign
}
    `;